import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class ExamenGenerico extends Examen {
  id = 106;
  code = 'EST';
  name = 'GENERICO';
  baseUrl = 'estudios/carga';
  observacionesMaxLength = 4000;
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'GENERICO',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],    
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
      },
      numberForm: 2,
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Examen',
      fields: {},
      numberForm: 3,
    },
    {
      name: 'Resultado',
      fields: {
        observaciones: [ '', [ Validators.required, Validators.maxLength( this.observacionesMaxLength ) ] ],
      },
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 5,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
        codigoDictamen: [ '', [ Validators.required ] ],
        matricula: ['', [Validators.required]],
        especialidad: ['', [Validators.required]],
      },
      numberForm: 4,
    },
  ];

  constructor( formBuilder: FormBuilder ) {
    super( formBuilder );
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}
